/**
 * Grid alignment Script
 */
{
  window.setGridHeight = (selector) => {
    let gridOffsets = [];
    let gridRowOffsets = [];
    let isMobile = window.innerWidth < 750;

    gridOffsets = Array.from(document.querySelectorAll(selector)).map((element,index) => {
      let grid = element.closest('.block-type-heading') || element.closest('slideshow-component') || element.closest('.group-block-content');
      if (!grid) return null;

      element.style.minHeight = '';
      return {
        selector: element,
        selectorHeight: element.offsetHeight,
        offsetTop: grid.offsetTop,
        offsetLeft: element.offsetLeft,
        gridElement: grid
      }
    }).filter(item => item !== null);

    // If mobile, check if we have only 1 column (unique horizontal offsets <= 1) and skip height matching
    if (isMobile) {
      gridOffsets = gridOffsets.filter(item => {
        let siblingsInGrid = gridOffsets.filter(x => x.gridElement === item.gridElement);
        let uniqueLefts = [];
        siblingsInGrid.forEach(x => {
          let left = x.offsetLeft;
          if (!uniqueLefts.some(val => Math.abs(val - left) < 5)) {
            uniqueLefts.push(left);
          }
        });
        if (uniqueLefts.length <= 1) {
          item.selector.style.minHeight = '';
          return false;
        }
        return true;
      });
    }

    let offsets = gridOffsets.map(element => element.offsetTop);
    gridRowOffsets = [...new Set(offsets)];

    gridRowOffsets.forEach(rowOffset => {
      let rowGrids = gridOffsets.filter(grid => (grid.offsetTop == rowOffset));
      let comanElementHeight = Math.max.apply(Math,(rowGrids.map(ele => ele.selectorHeight)));
      rowGrids.forEach(grid => {
        grid.selector.style.minHeight = comanElementHeight+'px';
      });
    });
  }

  window.matchHeightCallback = () => {
    window.setGridHeight('.js-heading-align');
    window.setGridHeight('.js-card-height');
  }

  setTimeout(() => {
    window.matchHeightCallback();
  }, 2000)
  
  window.addEventListener('resize', function(event){
    window.matchHeightCallback();
  });

  window.matchHeightCallback();
}

/* Horizontal Slider Script */
{
document.addEventListener('DOMContentLoaded', () => {
    initAllHorizontalSliders();
});

document.addEventListener('shopify:section:load', (e) => {
    const track = e.target.querySelector('.h-slider-track');
    if (track) initHorizontalSlider(track);
});

document.addEventListener('shopify:block:select', (e) => {
    const section = e.target.closest('.shopify-section');
    if (section) {
       const track = section.querySelector('.h-slider-track');
       if(track) initHorizontalSlider(track);
    }
});

document.addEventListener('shopify:block:deselect', (e) => {
    const section = e.target.closest('.shopify-section');
    if (section) {
       const track = section.querySelector('.h-slider-track');
       if(track) initHorizontalSlider(track);
    }
});

function initAllHorizontalSliders() {
    document.querySelectorAll('.h-slider-track').forEach(track => {
        initHorizontalSlider(track);
    });
}

function initHorizontalSlider(track) {
    const sliderContainer = track.querySelector('.h-slider-container');
    
    // Safety
    if (!sliderContainer) {
        track.style.height = '100vh';
        return;
    }

    const slides = Array.from(sliderContainer.querySelectorAll('.h-slide'));
    
    if (slides.length === 0) {
        track.style.height = '100vh';
        return;
    }

    // Create/Reference Fixed Text Layer
    let textLayer = sliderContainer.querySelector('.h-fixed-text-layer');
    if (!textLayer) {
        textLayer = document.createElement('div');
        textLayer.classList.add('h-fixed-text-layer');
        sliderContainer.appendChild(textLayer);
        
        // Clone text items
        slides.forEach((slide, i) => {
            const originalText = slide.querySelector('.h-text-side');
            if (originalText) {
                const clone = originalText.cloneNode(true);
                clone.className = 'h-cloned-text-item section-' + track.id.replace('Track-', '') + '-padding'; 
                // Clear any inline styles that might interfere with CSS
                clone.style.opacity = ''; 
                clone.style.pointerEvents = '';
                clone.style.transform = '';
                
                textLayer.appendChild(clone);
            }
        });
    }

    const clonedTextItems = Array.from(textLayer.querySelectorAll('.h-cloned-text-item'));

    let currentScroll = 0;
    let targetScroll = 0;
    const ease = 0.075; 
    
    function lerp(start, end, t) {
        return start * (1 - t) + end * t;
    }

    function adjustHeight() {
         const slidesNow = Array.from(sliderContainer.querySelectorAll('.h-slide'));
         if (slidesNow.length === 0) return;

         // Measure header text height and set CSS variable
         const headerText = sliderContainer.querySelector('.js-header-text-height');
         if (headerText) {
             sliderContainer.style.setProperty('--js-header-text-height', headerText.offsetHeight + 'px');
         }
         
         // Reset and Measure
         let maxContentHeight = 0;
         let maxImageHeight = 0;
          /** @type {HTMLElement[]} */
          const slideBodies = [];
         slidesNow.forEach(slide => {
             const textSide = slide.querySelector('.h-text-side');
             const imageSide = slide.querySelector('.h-image-side');
             const slideBody = slide.querySelector('.h-slide-body');
             
             if(slideBody) {
                 slideBody.style.removeProperty('--content-height'); 
                 slideBody.style.removeProperty('--image-height');
                 slideBodies.push(slideBody);
             }

             if(textSide) {
                const h = textSide.offsetHeight;
                if(h > maxContentHeight) maxContentHeight = h;
             }
             
             if(imageSide) {
                const h = imageSide.offsetHeight;
                if(h > maxImageHeight) maxImageHeight = h;
             }
         });
         
         // Apply to all
         slideBodies.forEach(sb => {
             sb.style.setProperty('--content-height', maxContentHeight + 'px');
             sb.style.setProperty('--image-height', maxImageHeight + 'px');
         });
         
         const winH = window.innerHeight;
         let scrollStep = winH;
         if (window.innerWidth < 750) {
             scrollStep = winH * 0.6;
         }

         const sliderHeight = (slidesNow.length - 1) * scrollStep + winH;
         track.style.height = sliderHeight + 'px';
         track.dataset.scrollStep = scrollStep;
         sliderContainer.style.height = '100vh';
    }

    function updateSlides() {
        const sectionRect = track.getBoundingClientRect();
        let relativeScroll = -sectionRect.top;
        if (relativeScroll < 0) relativeScroll = 0;
        
        targetScroll = relativeScroll;
        
        const winH = window.innerHeight;
        const winW = window.innerWidth;
        
        currentScroll = lerp(currentScroll, targetScroll, ease);
        
        let scrollStep = winH;
        if (track.dataset.scrollStep) {
             scrollStep = parseFloat(track.dataset.scrollStep);
        }
        
        const S = currentScroll / scrollStep;

        const w80 = winW * 0.80;
        const w15 = winW * 0.15;
        const w10 = winW * 0.15; 
        const wFull = winW;
        
        const pos2 = w80;        
        const pos3 = w80 + w15;
        
        // Progress Logic
        const progressBar = sliderContainer.querySelector('.h-progress-fill');
        const navItems = sliderContainer.querySelectorAll('.h-nav-item');
        if (progressBar && slides.length > 0) {
             const totalSlides = slides.length;
             let pPercent = ((S + 1) / totalSlides) * 100;
             if (pPercent < 0) pPercent = 0;
             if (pPercent > 100) pPercent = 100;
             progressBar.style.width = pPercent + '%';
        }
        
        // Update Nav Active States & Scroll
        const navItemsContainer = sliderContainer.querySelector('.h-nav-items');
        if (navItems.length > 0) {
             navItems.forEach((item, i) => {
                const label = item.querySelector('.label');
                if (i <= S + 0.3) {
                    item.classList.add('active');
                } else {
                    item.classList.remove('active');
                }
             });

            const totalS = slides.length;
            if (totalS > 1) {
                const wrapper = navItemsContainer.parentElement;
                const scrollableWidth = navItemsContainer.offsetWidth - (wrapper ? wrapper.clientWidth : wFull);
                if (scrollableWidth > 0) {
                    const progress = Math.max(0, Math.min(1, S / (totalS - 1)));
                    const translateX = -(progress * scrollableWidth);
                    navItemsContainer.style.transform = `translateX(${translateX}px)`;
                }
            }
        }


        slides.forEach((slide, i) => {
            let width = w10; 
            let left = wFull; 
            let top = 0;
            let zIndex = 0;
            
            const k = S - i;
            const isLast = i === slides.length - 1;

            if (wFull < 750) {
                // Mobile: Vertical Stacking (Bottom to Top)
                width = wFull; 
                left = 0;
                
                // k = S - i
                // If k >= 0: Slide is active/past (should be at top)
                // If -1 <= k < 0: Slide is entering (from bottom)
                // If k < -1: Slide is waiting at bottom
                
                if (k >= 0) {
                     top = 0;
                     zIndex = i;
                } else if (k >= -1 && k < 0) {
                     // -k goes from 1 to 0
                     top = (winH * (-k)); 
                     zIndex = i + 1; // Ensure entering slide is above
                } else {
                     top = winH;
                     zIndex = 0;
                }
                
            } else {
                // Desktop: Horizontal Logic
                if (k <= -3) {
                    left = wFull; width = w10; zIndex = 0;
                } else if (k > -3 && k <= -2) {
                    const p = k + 3;
                    left = wFull + (pos3 - wFull) * p;
                    width = w10;
                    zIndex = 10;
                } else if (k > -2 && k <= -1) {
                    const p = k + 2;
                    left = pos3 + (pos2 - pos3) * p;
                    width = w10 + (w15 - w10) * p;
                    zIndex = 20;
                } else if (k > -1 && k < 0) {
                    const p = k + 1;
                    left = pos2 + (0 - pos2) * p;
                    
                    let targetWidth = w80;
                    if (isLast) targetWidth = wFull;
                    
                    width = w15 + (targetWidth - w15) * p;
                    zIndex = 30;
                } else if (k >= 0 && k < 1) {
                    left = 0;
                    width = w80;
                    if (isLast) width = wFull;
                    zIndex = 0;
                }
                
                if (isLast && left < wFull) width = wFull - left;
            }

            slide.style.width = width + 'px';
            slide.style.left = left + 'px';
            slide.style.top = top + 'px';
            slide.style.zIndex = Math.floor(zIndex);
            
            if (k > -0.5 && k < 0.5) {
                slide.classList.add('active');
            } else {
                slide.classList.remove('active');
            }

            // Continuous Text Opacity (As scroll happens)
            // k=0 => opacity=1. k=-1 or k=1 => opacity=0.
            if (clonedTextItems[i]) {
                const item = clonedTextItems[i];
                
                // Clear inline styles to let CSS handle it
                item.style.opacity = ''; 
                item.style.pointerEvents = '';
                item.style.zIndex = i; 
                item.style.display = ''; 
                
                if (k > -0.5 && k < 0.5) {
                    item.classList.add('active');
                } else {
                    item.classList.remove('active');
                }
            }

            const imageSide = slide.querySelector('.h-image-side');
            if (imageSide) {
                if (wFull < 750) {
                     imageSide.style.transform = 'none';
                     imageSide.style.opacity = 1;
                } else {
                    if (k >= -1 && k <= 0) {
                        const p = k + 1; 
                        const scale = 0.3 + (0.7 * p);
                        const yVal = 20 * (1 - p); 
                        imageSide.style.transform = `scale(${scale}) translateY(${yVal}vh)`;
                        imageSide.style.opacity = 1; 
                    } else if (k > 0 && k < 1) {
                            imageSide.style.transform = `scale(1) translateY(0)`;
                            imageSide.style.opacity = 1;
                    } else {
                        imageSide.style.transform = `scale(0.3) translateY(20vh)`;
                        if (k > 1) imageSide.style.opacity = 0;
                        else imageSide.style.opacity = 1; 
                    }
                }
            }
        });
        
        requestAnimationFrame(updateSlides);
    }
    
    updateSlides();
    window.addEventListener('resize', adjustHeight);
    adjustHeight();
}
}
// ==================================
/* Dynamic SVG Loader for Hero Dev / Section */
{
  document.addEventListener('DOMContentLoaded', function () {
    const ANIMATION_START_DELAY_MS = 120;

    function isContainerVisible(el) {
      const container = el.closest('.custom-svg-container');
      if (!container) return true;
      return window.getComputedStyle(container).display !== 'none';
    }

    function prepareShapes(shapes) {
      shapes.forEach((el) => {
        const stroke = el.getAttribute('stroke');
        const fill = el.getAttribute('fill');
        const hasStroke = stroke && stroke !== 'none';
        const hasFill = fill && fill !== 'none';

        if (!hasStroke && hasFill) {
          el.setAttribute('data-wave-ready', 'true');
          el.style.opacity = '1';
          return;
        }

        if (!el.getAttribute('stroke')) {
          el.setAttribute('stroke', 'currentColor');
        }
        if (!el.getAttribute('stroke-width')) {
          el.setAttribute('stroke-width', '1');
        }
        if (!el.getAttribute('fill')) {
          el.setAttribute('fill', 'none');
        }

        el.setAttribute('pathLength', '1');
        el.style.animation = 'none';
        el.style.strokeDasharray = '1';
        el.style.strokeDashoffset = '1';
        el.setAttribute('data-wave-ready', 'true');
        el.style.opacity = '1';
      });
    }

    function startWhenReady(shapes, svg) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setTimeout(() => {
            if (typeof startAnimation === 'function') {
              startAnimation(shapes, svg);
            }
          }, ANIMATION_START_DELAY_MS);
        });
      });
    }

    document.querySelectorAll('.dynamic-svg').forEach(async (el) => {
      const url = el.getAttribute('data-url');
      if (!url) return;

      // Don't fetch/animate hidden mobile or desktop duplicate
      if (!isContainerVisible(el)) {
        el.classList.add('is-loaded');
        return;
      }

      el.classList.remove('is-loaded');
      el.style.visibility = 'hidden';

      try {
        const res = await fetch(url);
        const text = await res.text();
        el.innerHTML = text;
        const svg = el.querySelector('svg');
        if (!svg) {
          el.style.visibility = '';
          el.classList.add('is-loaded');
          return;
        }

        svg.setAttribute('preserveAspectRatio', 'none');
        const shapes = svg.querySelectorAll(
          'path, line, polyline, polygon, rect, circle, ellipse'
        );

        prepareShapes(shapes);
        void svg.getBoundingClientRect();
        el.style.visibility = '';
        el.classList.add('is-loaded');

        const root = el.closest('.animation-group-root');
        const slide = el.closest('slideshow-slide');

        if (slide) {
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.attributeName === 'aria-hidden') {
                if (slide.getAttribute('aria-hidden') !== 'true') {
                  svg.removeAttribute('data-wave-started');
                  startWhenReady(shapes, svg);
                } else if (typeof resetAnimation === 'function') {
                  resetAnimation(shapes, svg);
                }
              }
            });
          });
          observer.observe(slide, { attributes: true });

          if (slide.getAttribute('aria-hidden') !== 'true') {
            startWhenReady(shapes, svg);
          } else if (typeof resetAnimation === 'function') {
            resetAnimation(shapes, svg);
          }
        } else {
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  startWhenReady(shapes, svg);
                  observer.disconnect();
                }
              });
            },
            { threshold: 0.1 }
          );
          observer.observe(root || el);
        }
      } catch (e) {
        console.error('Error loading SVG:', e);
        el.style.visibility = '';
        el.classList.add('is-loaded');
      }
    });
  });
}
// ==================================

/* Scroll-to-section buttons (theme editor + storefront) */
{
  function scrollToSectionId(sectionId) {
    if (!sectionId) return;
    const target = document.getElementById(sectionId);
    if (!target) return;

    const headerOffset =
      parseFloat(getComputedStyle(document.body).getPropertyValue('--header-group-height')) || 0;
    const top = target.getBoundingClientRect().top + window.scrollY - headerOffset;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });

    if (history.replaceState) {
      history.replaceState(null, '', `#${sectionId}`);
    }
  }

  function bindScrollToSection(root) {
    const scope = root || document;
    scope.querySelectorAll('a[data-scroll-to-section]').forEach((link) => {
      if (link.dataset.scrollBound === 'true') return;
      link.dataset.scrollBound = 'true';
      link.addEventListener('click', (event) => {
        const sectionId = link.getAttribute('data-scroll-to-section');
        if (!sectionId || !document.getElementById(sectionId)) return;
        event.preventDefault();
        scrollToSectionId(sectionId);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => bindScrollToSection());
  document.addEventListener('shopify:section:load', (event) => bindScrollToSection(event.target));
  document.addEventListener('shopify:section:reorder', () => bindScrollToSection());
  bindScrollToSection();
}
